const map = {
	"./CloudPageTitle.razor.js": "./UIKit/CloudPageTitle.razor.js",
	"./CountdownTimer.razor.js": "./UIKit/CountdownTimer.razor.js",
	"./FlyoutMenu.razor.js": "./UIKit/FlyoutMenu.razor.js",
	"./Indicator.razor.js": "./UIKit/Indicator.razor.js",
	"./InlineTextInput.razor.js": "./UIKit/InlineTextInput.razor.js",
	"./ModalContainer.razor.js": "./UIKit/ModalContainer.razor.js",
	"./PageTopPanelBreadCrumbCompact.razor.js": "./UIKit/PageTopPanelBreadCrumbCompact.razor.js",
	"./PreviewSelectorComponent.razor.js": "./UIKit/PreviewSelectorComponent.razor.js",
	"./SideBarCommon.razor.js": "./UIKit/SideBarCommon.razor.js"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./UIKit sync recursive ^.*\\.razor\\.js$";